<template>
  <div>
    <div v-if='isViewMode'>
      {{field.value}}
    </div>
    <input
      v-else
      type='text'
      v-model='field.value'
      @blur='handleUpdate'
      class='form-input w-full'/>
  </div>
</template>

<script>

export default {
  name: 'CustomFieldText',
  props: [ 'field', 'isViewMode' ],
  methods: {
    handleUpdate () {
      this.$emit('update-value', this.field)
    }
  },
}
</script>
